export default __webpack_public_path__ + "static/media/2192.e6f2b818.png";